import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import toggleDynamicTabOperation from 'editor/src/store/editorModules/sidebar/operation/toggleDynamicTabOperation';
import { TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';
import { setQuantitySavingsQuoteAction } from 'editor/src/store/quantitySavings/slice';
import { QuantitySavingsQuote } from 'editor/src/store/quantitySavings/types';

/**
 * Handles `quantitySavings.setQuote`. The stepper lives in the Product tab, which a host does not list for a
 * single-variant product, so the first quote adds it without moving the shopper off the tab they have open.
 * A withdrawn quote leaves the tab in place rather than pulling it from under the shopper.
 */
const setQuantitySavingsQuoteOperation =
  (quote: QuantitySavingsQuote | null) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    batch(() => {
      dispatch(setQuantitySavingsQuoteAction(quote));
      const { dynamicTabs } = getState().editorModules.sidebar;
      if (quote && !dynamicTabs.some(({ tab }) => tab === TAB_NAMES.PRODUCT)) {
        dispatch(toggleDynamicTabOperation(TAB_NAMES.PRODUCT, true, 0, { keepActiveTab: true }));
      }
    });
  };

export default setQuantitySavingsQuoteOperation;
